import { reactive } from "vue"
import GlobalPrefsService from "../../services/globalPrefsService"

const snackOptions = reactive({
    color: "info",
    show: false,
    msg: null,
    msgs: null,
    timeout: 3000,
    position: "bottom", // top | bottom
    autoClose: false,
    linkText: null,
    href: null,
});

function hide()
{
    snackOptions.show = false;
    return null
}
  
function show(options = {})
{
    Object.assign(snackOptions, {
        color: "info",
        msg: null,
        msgs: null,
        position: "bottom",
        autoClose: false,
        linkText: null,
        href: null,
        timeout: GlobalPrefsService.getSnackbarDisplayTimeout() || 3000,
        ...options,
        show: true,
    });
    if (!snackOptions.msg && (!snackOptions.msgs || snackOptions.msgs.length === 0)) {
        snackOptions.show = false;
        console.error("Snackbar called without a message");
    }

    if (isNaN(snackOptions.timeout)) {
        console.log("timeout");
        snackOptions.show = false;
        console.error("Snackbar timeout must be a number");
    }
}

export function Snackbar()
{
    return {
        snackOptions,
        show,
        hide,
    };
}
